import { Sort as IconSort } from '../icons/Icons';

import useTableSortHeader from './UseTableSortHeader';

import tableStyle from '../../Table.module.css';

/**
 * Styling component for headers that contain an input.
 * Aligns it's children to the center.
 */
const Input = ({ colSpan = 1, className = '', style = undefined, children }) => (
  <th className={[tableStyle.Input, className].join(' ')} style={style} colSpan={colSpan}>
    <div className={tableStyle.Flex}>
      {children}
    </div>
  </th>
);

/**
 * Styling component for headers that contain action buttons. 
 * Aligns it's children to the right.
 */
const Action = ({ colSpan = 1, className = '', style = undefined, children }) => (
  <th className={[tableStyle.Action, className].join(' ')} style={style} colSpan={colSpan}>
    <div className={tableStyle.Flex}>
      {children}
    </div>
  </th>
);

/**
 * Functional component for headers the table can be sorted by. 
 * Changes sort direction when clicked multiple times.
 * @param {String} sortKey key to be sorted by, i.e. 'lastName'
 * @param {String} sortType the type of sorting logic to use, i.e. SORT_TYPES.ALPHABETICAL
 */
const Sort = ({ sortKey, sortType, colSpan = 1, className = '', style = undefined, children }) => {
  const { isSortedHeader, sortDirection, onHeaderClicked } = useTableSortHeader(sortKey);

  return (
    <th className={[tableStyle.Sort, className].join(' ')}
      title={`Sort By ${String(children)}`}
      style={style}
      colSpan={colSpan}
      onClick={(e) => onHeaderClicked(e, sortType)}>
      <div className={tableStyle.Flex}>
        <span>{children}</span> <IconSort toolTipText={`Sort By ${String(children)}`} isSorted={isSortedHeader === true} sortDirection={sortDirection} onClick={(e) => onHeaderClicked(e, sortType)} />
      </div>
    </th>
  );
};

export { Sort, Action, Input };